import { Component } from 'react'
import { object } from 'prop-types'
import { stores } from '../../stores'
import { getUrlParam } from '../../utilities/url'

/**
 * 'Super' component to handle inquiries details page container & logic - pretty much the same for all pages
 */
export class InquiryPage extends Component {
  get type () { throw new Error('Please provide a type to the class') }
  get frequency () { throw new Error('Please provide a frequency to the class') }

  async componentDidMount () {
    await this.getInquiry()
    const selectedPurchase = 'selectedPurchase'
    const selectedPurchaseId = getUrlParam(this.props.location.search, selectedPurchase)
    if (selectedPurchaseId !== null) {
      this.selected(selectedPurchaseId)
    }
  }

  async getInquiry () {
    const { match } = this.props
    await stores.inquiries.get({ id: match.params.id, type: this.type, frequency: this.frequency })
  }

  get ready () {
    const { match } = this.props
    const { inquiry, loading } = stores.inquiries
    return inquiry && inquiry.id === match.params.id && !loading
  }
}

InquiryPage.propTypes = {
  match: object
}



// WEBPACK FOOTER //
// ./src/pages/demandes/InquiryPage.js